export const USER_LOAD_STARTED = 'USER_LOAD_STARTED';
export const USER_LOAD_FAILED = 'USER_LOAD_FAILED';
export const USER_LOAD_SUCCESS = 'USER_LOAD_SUCCESS';
export const USER_LOAD_RESET = 'USER_LOAD_RESET';
export const USER_UPDATE_STARTED = 'USER_UPDATE_STARTED';
export const USER_UPDATE_FAILED = 'USER_UPDATE_FAILED';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_RESET = 'USER_UPDATE_RESET';
